"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinePlaceholder = exports.MultiLinePlaceholder = exports.Placeholder = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Table_1 = __importDefault(require("../Table"));
var _ = __importStar(require("lodash"));
var BootstrapHelper_1 = require("../../BootstrapHelper");
var Placeholder = function (props) {
    var C = {
        TablePlaceholder: TablePlaceholder
    };
    var K = C[props.type + "Placeholder"];
    return props.showIf ? (0, jsx_runtime_1.jsx)(K, __assign({}, props.componentProps)) : (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: props.children });
};
exports.Placeholder = Placeholder;
var TablePlaceholder = function (props) {
    if (!props) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(Table_1.default.Table, { children: [(0, jsx_runtime_1.jsx)(Table_1.default.Header, { children: _.range(0, props.numberOfColumns).map(function (e) {
                    return ((0, jsx_runtime_1.jsx)(Table_1.default.HeaderCol, { children: (0, jsx_runtime_1.jsx)(exports.LinePlaceholder, {}) }, e));
                }) }), (0, jsx_runtime_1.jsx)(Table_1.default.Body, { children: _.range(0, props.numberOfRows).map(function (e, i) {
                    return ((0, jsx_runtime_1.jsx)(Table_1.default.Row, { children: _.range(0, props.numberOfColumns).map(function (e) {
                            return ((0, jsx_runtime_1.jsx)(Table_1.default.Col, { children: (0, jsx_runtime_1.jsx)(exports.LinePlaceholder, {}) }, e));
                        }) }, e));
                }) })] }));
};
var MultiLinePlaceholder = function (props) {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(exports.LinePlaceholder, __assign({}, props)), (0, jsx_runtime_1.jsx)(exports.LinePlaceholder, __assign({}, props)), (0, jsx_runtime_1.jsx)(exports.LinePlaceholder, __assign({}, props))] }));
};
exports.MultiLinePlaceholder = MultiLinePlaceholder;
var LinePlaceholder = function (props) {
    var cls = (0, BootstrapHelper_1.B)()
        .bl("placeholder")
        .pmod("animated")
        .pmod("line")
        .pmod(props.type || "primary").bem;
    return (0, jsx_runtime_1.jsx)("div", { className: "".concat(cls, " ").concat(props.className || "") });
};
exports.LinePlaceholder = LinePlaceholder;
